module.exports = __webpack_public_path__ + "img/plan.03cc3391.png";